import * as prismic from '@prismicio/client'

// Repository name from environment — set GATSBY_PRISMIC_REPO_NAME before building
export const repositoryName = `${process.env.GATSBY_PRISMIC_REPO_NAME}`

export const client = prismic.createClient(repositoryName, {
  // Access token — set GATSBY_PRISMIC_ACCESS_TOKEN before building
  accessToken: `${process.env.GATSBY_PRISMIC_ACCESS_TOKEN}`,
})
